import { createPortal } from 'react-dom';
import styled, { keyframes } from 'styled-components';
import { useAuth } from '../../context/AuthProvider';
import { useModal } from '../../context/ModalProvider';
import ThemeToggle from '../../components/ThemeToggle';
import {
  cyberGlassBackdrop,
  cyberGlassSurface,
  cyberGlassTextMuted,
  cyberGlassTextPrimary,
} from '../../styles/cyberGlass';

const appear = keyframes`
  0%   { transform: scale(0.8); opacity: 0; }
  60%  { transform: scale(1.05); }
  100% { transform: scale(1); opacity: 1; }
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  ${cyberGlassBackdrop};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 80;
`;

const Panel = styled.div`
  position: relative;
  width: 100%;
  max-width: 380px;
  ${cyberGlassSurface};
  color: ${cyberGlassTextPrimary};
  border-radius: 24px;
  padding: 2rem;
  animation: ${appear} 0.35s cubic-bezier(.22,1.44,.46,.99);
`;

const Section = styled.div`
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${cyberGlassTextMuted};
`;

export default function SettingsModal() {
  const { close } = useModal();
  const { user } = useAuth();

  if (!user) return null;

  return createPortal(
    <Backdrop onClick={close}>
      <Panel onClick={(event) => event.stopPropagation()}>
        <h3 style={{ marginTop: 0 }}>Account settings</h3>

        <p>
          <strong>Email:</strong> {user.email}
        </p>

        <Section>
          <span>Theme</span>
          <ThemeToggle />
        </Section>

        <button onClick={close} style={{ marginTop: '2rem', width: '100%' }}>
          Close
        </button>
      </Panel>
    </Backdrop>,
    document.body,
  );
}
